import type { CampaignImpactMetricName } from "../types";

const COUNT_METRICS: CampaignImpactMetricName[] = ["UPLIFT_IN_BOOKINGS", "UPLIFT_IN_PASSENGERS"];

export const isPercentageMetric = (name: CampaignImpactMetricName): boolean => !COUNT_METRICS.includes(name);

/**
 * Round a KPI value to the same precision it is displayed with on the card.
 * Percentages are rounded to 1 decimal place; counts are rounded to an integer.
 * `-0` is normalized to `0` so downstream sign checks treat near-zero negatives as zero.
 */
export const roundKpiValue = (value: number, name: CampaignImpactMetricName): number => {
  const rounded = isPercentageMetric(name) ? Number(value.toFixed(1)) : Math.round(value);
  return rounded === 0 ? 0 : rounded;
};
